import { BackofficeARIDTO, DailySet } from "../types";
import { StaticDiscountData } from "../../../../gen/witbooking/ari/v1/static_ari_pb";

const getDailySet = (startDate: string, endDate: string, dailySet: DailySet[]): DailySet[] =>
  dailySet ? dailySet : [{ startDate, endDate, value: false }];

interface DailyValues {
  closed?: {
    dailySet?: DailySet[];
  };
}

export class PromotionData {
  ticker: string;
  dailyValues: DailyValues;

  constructor(ticker: string, dailyValues: DailyValues) {
    this.ticker = ticker;
    this.dailyValues = dailyValues;
  }

  static of(
    backofficeAriDto: BackofficeARIDTO,
    staticDiscountData: StaticDiscountData.AsObject[],
    startDate: string,
    endDate: string
  ): PromotionData[] {
    return staticDiscountData
      .filter(
        ({ bucketConfig }) =>
          bucketConfig?.lock && !bucketConfig.lock.parentTicker && !bucketConfig.lock.constant
      )
      .map(
        it =>
          new PromotionData(it.ticker, {
            closed: {
              dailySet: getDailySet(
                startDate,
                endDate,
                backofficeAriDto[it.ticker]?.closed?.dailySet
              ),
            },
          })
      );
  }
}
